/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Hardware_Info_PlaceholderInputs */

const en_svr_hardware_info_placeholder = /** @type {(inputs: Svr_Hardware_Info_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If hardware was replaced, include part codes and serial numbers (old and new). Indicate if you removed/left a part and where, onsite contact details, and photo notes.`)
};

const ja_svr_hardware_info_placeholder = /** @type {(inputs: Svr_Hardware_Info_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハードウェアを交換した場合、部品コードとシリアル番号（旧・新）を含めてください。部品を持ち帰った/残した場合はその場所、現場連絡先、写真メモを記載してください。`)
};

const fr_svr_hardware_info_placeholder = /** @type {(inputs: Svr_Hardware_Info_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si du matériel a été remplacé, indiquez les codes pièces et numéros de série (ancien et nouveau). Précisez si vous avez retiré/laissé une pièce et où, les coordonnées du contact sur site et les notes photo.`)
};

const de_svr_hardware_info_placeholder = /** @type {(inputs: Svr_Hardware_Info_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Hardwaretausch: Teilenummern und Seriennummern (alt und neu). Geben Sie an, ob Sie ein Teil mitgenommen/vor Ort gelassen haben und wo, Kontaktdaten vor Ort und Fotohinweise.`)
};

/**
* | output |
* | --- |
* | "If hardware was replaced, include part codes and serial numbers (old and new). Indicate if you removed/left a part and where, onsite contact details, and pho..." |
*
* @param {Svr_Hardware_Info_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_hardware_info_placeholder = /** @type {((inputs?: Svr_Hardware_Info_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Hardware_Info_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_hardware_info_placeholder(inputs)
	if (locale === "ja") return ja_svr_hardware_info_placeholder(inputs)
	if (locale === "fr") return fr_svr_hardware_info_placeholder(inputs)
	return de_svr_hardware_info_placeholder(inputs)
});